export interface AssessmentItem {
  title: string;
  description: string;
}


export const ASSESSMENT_ITEMS: AssessmentItem[] = [
  {
    title: "Soft Credit Review",
    description: "Soft Credit Review blends our proprietary algorithms with optional face-to-face consulting for a flexible, hybrid credit assessment. Clients can choose a fully automated review or connect with a consultant for the full intake and assessment, gaining transparent reasoning and a comprehensive assessment that highlights inaccuracies, analyzes payment history, identifies barriers to loan approval, and presents the client’s overall lending profile with clear, personalized guidance and next steps."
  },
  {
    title: "Personalized Financial Analysis", 
    description: "An in-depth review of the client's financial situation."
  },
  {
    title: "Prequalification Assessment",
    description: "Determination of eligibility for various loan options."
  },
  {
    title: "Customized Recommendations",
    description: "Tailored strategies to improve credit standing or financial health."
  },
  {
    title: "Loan Program Options",
    description: "Identification of suitable loan or financing programs."
  },
  {
    title: "Lending Profile Improvement Tips",
    description: "Actionable advice to boost profile and FICO scores."
  },
  {
    title: "Debt Management Strategies",
    description: "Guidance on managing and reducing existing debts."
  },
  {
    title: "Documentation Guidance",
    description: "Assistance with gathering and preparing necessary documents."
  },
  {
    title: "Understanding Qualification Criteria",
    description: "Clear explanation of what lenders look for."
  },
  {
    title: "Next Steps Planning",
    description: "A roadmap for the application process and future actions."
  },
  {
    title: "Resource Recommendations",
    description: "Suggested tools, apps, or our Trusted Partners resource"
  },
  {
    title: "Financial Goal Clarification",
    description: "Help in defining and prioritizing financial objectives."
  },
  {
    title: "Timeframe Expectations",
    description: "Clarification of realistic timelines for prequalification and approval."
  },
  {
    title: "Addressing Lending Profile Concerns",
    description: "Expert advice on handling past issues."
  },
  {
    title: "Confidence Building",
    description: "Empowering clients with knowledge and clarity about their consumer financial readiness."
  }
];


